import React, { useState } from "react";
import "./App.css";
import { realtyStore } from "./Realty/store";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { SignUp } from "./Realty/pages/SignUp";
import { CookiesProvider } from "react-cookie";
import { AuthHoc } from "./Realty/components/hocs/AuthHoc";
import { HousingComplexShared } from "./Realty/pages/Shared/components/HousingComplexShared";
import { Header } from "./Realty/components/common/Header";
import { ImagesUpload } from "./Realty/pages/ImagesUpload";
import { Footer } from "./Realty/components/common/Footer";
import { VerifyEmail } from "./Realty/pages/VerifyEmail";
import { Payment } from "./Realty/pages/Payment";
import { Notification } from "./Realty/components/common/Notification";
import { ResetPassword } from "./Realty/pages/ResetPassword";
import { ContractAssignment } from "./Realty/pages/ContractAssignment/components/ContractAssignmentsList";
import { ContractAssignmentEditor } from "./Realty/pages/ContractAssignment/components/ContractAssignmentEditor";
import { ContractAssignmentItem } from "./Realty/pages/ContractAssignment/components/ContractAssignmentItem";
import {isDune, isLanding, isTestStand} from "./Realty/constants/common";
import { Housings } from "./Realty/pages/Housings";
import { HousingComplex } from "./Realty/pages/HousingComplex";
import { ScrollAwareBlock } from "./Realty/components/common/ScrollAwareBlock";
import { SideMenu } from "./Realty/components/common/Header/components/UserBar/components/SideMenu";
import { MainPage } from "./Realty/pages/MainPage";
import { PublicHome } from "./Realty/pages/PublicHome";
import { ImageGenerator } from "./Realty/pages/ImageGenerator";
import { RamadanVillage } from "./Realty/pages/landings/RamadanVillage";
import { AISearchPage } from "./Realty/pages/AISearchPage";
import { CollectionPage } from "./Realty/pages/CollectionPage";
import { PersonalDataPage } from "./Realty/pages/PersonalDataPage";
import { ClientBasePage } from "./Realty/pages/ClientBasePage";
import { ClassifiedsBoard } from "./Realty/pages/ClassifiedsBoard";
import { ClassifiedsModeration } from "./Realty/pages/ClassifiedsModeration";
import { ClassifiedListingDetail } from "./Realty/pages/ClassifiedListingDetail";
import { ClassifiedsUserListings } from "./Realty/pages/ClassifiedsUserListings";
import { CooperationModels } from "./Realty/pages/CooperationModels";
import { CooperationModelsEditor } from "./Realty/pages/CooperationModelsEditor";
import { BrandedShowcase } from "./Realty/pages/BrandedShowcase";
import { BrandStudio } from "./Realty/pages/BrandStudio";
import {
  EMAIL_VERIFICATION_ROUTE,
  isEmailVerificationPath,
} from "./Realty/routes/emailVerification";

import DuneMainPage from "./Realty/pages/byeByeDune";
import ControlPanel from "./Realty/pages/ControlPanel";
import { AnalyticsObserver } from "./Realty/analytics/AnalyticsObserver";

const STANDALONE_ROUTES = [
  "/cooperation-models",
  "/cooperation-models-editor",
  "/brand-studio",
];

function AppContent() {
  const [sideMenuIsOpen, setSideMenuIsOpen] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isStandaloneRoute = STANDALONE_ROUTES.some((route) =>
    location.pathname.startsWith(route),
  );
  const isEmailVerificationRoute = isEmailVerificationPath(location.pathname);
  const isBrandedShowcaseRoute = location.pathname.startsWith("/brand=");
  const isSharedHousingRoute = location.pathname.startsWith("/shared/housing/");
  const isBrandedSharedHousingRoute =
    isSharedHousingRoute && searchParams.has("brand");

  if (isTestStand) {
    console.log("Current Git Branch:", process.env.REACT_APP_GIT_BRANCH);
  }
  return (
    <>
      <CookiesProvider>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Provider store={realtyStore}>
          <AnalyticsObserver />
          {isEmailVerificationRoute ? (
            <Routes>
              <Route
                path={EMAIL_VERIFICATION_ROUTE}
                element={<VerifyEmail />}
              />
            </Routes>
          ) : isStandaloneRoute ? (
            <Routes>
              <Route path="/cooperation-models" element={<CooperationModels />} />
              <Route
                path="/cooperation-models-editor"
                element={<CooperationModelsEditor />}
              />
              <Route path="/brand-studio" element={<BrandStudio />} />
            </Routes>
          ) : isBrandedSharedHousingRoute ? (
            <Routes>
              <Route path="/shared/housing/:id/" element={<HousingComplexShared />} />
            </Routes>
          ) : isBrandedShowcaseRoute ? (
            <BrandedShowcase />
          ) : (
            <AuthHoc>
              <ScrollAwareBlock
                className="header_scroll-container"
                position="top"
                offset={80}
                shadow={true}
                offsetTransparent={isLanding}
                hideOnScroll={false}
              >
                <Header setSideMenuIsOpen={setSideMenuIsOpen} />
              </ScrollAwareBlock>

              <SideMenu isOpen={sideMenuIsOpen} setIsOpen={setSideMenuIsOpen} />

              <Routes>
                {isDune ? (
                    <>
                      <Route path="/" element={<DuneMainPage />} />
                      <Route path="*" element={<DuneMainPage />} />
                    </>
                ) : (
                    <>
                      <Route path="/landing/ramadan-village" element={<RamadanVillage />} />

                      <Route path="/" element={<PublicHome />} />
                      <Route path="/housings" element={<Housings />} />

                      <Route
                          path="/housing-complex/:id/"
                          element={<HousingComplex key="residential" type="residential" />}
                      />
                      <Route
                          path="/commerce-complex/:id/"
                          element={<HousingComplex key="commerce" type="commerce" />}
                      />

                      <Route path="/signup" element={<SignUp />} />
                      <Route path="/signin" element={<MainPage />} />
                      <Route path="/payment" element={<Payment />} />
                      <Route path="/images-upload" element={<ImagesUpload />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route path="/shared/housing/:id/" element={<HousingComplexShared />} />

                      <Route path="/contract-assignment" element={<ContractAssignment />} />
                      <Route path="/contract-assignment/by-user/:userId" element={<ContractAssignment />} />
                      <Route path="/contract-assignment/:id" element={<ContractAssignmentItem />} />
                      <Route path="/contract-assignment/:id/:agentId" element={<ContractAssignmentItem />} />
                      <Route path="/contract-assignment/edit/:id" element={<ContractAssignmentEditor />} />
                      <Route path="/contract-assignment/create" element={<ContractAssignmentEditor />} />

                      <Route path="/image-generator" element={<ImageGenerator />} />
                      <Route path="/ai-search" element={<AISearchPage />} />
                      <Route path="/personal-data" element={<PersonalDataPage />} />
                      <Route path="/collection/:code" element={<CollectionPage />} />
                      <Route path="/client-base" element={<ClientBasePage />} />
                      <Route path="/classifieds" element={<ClassifiedsBoard key="classifieds-catalog" />} />
                      <Route path="/classifieds/my" element={<ClassifiedsBoard key="classifieds-my" myMode />} />
                      <Route path="/classifieds/favorites" element={<ClassifiedsBoard key="classifieds-favorites" favoriteMode />} />
                      <Route path="/classifieds/moderation" element={<ClassifiedsModeration />} />
                      <Route path="/classifieds/create" element={<ClassifiedsBoard key="classifieds-create" createMode />} />
                      <Route path="/classifieds/users/:userId" element={<ClassifiedsUserListings />} />
                      <Route path="/classifieds/shared/:token" element={<ClassifiedListingDetail />} />
                      <Route path="/classifieds/:type/:id/edit" element={<ClassifiedsBoard key="classifieds-edit" editMode />} />
                      <Route path="/classifieds/:type/:id" element={<ClassifiedListingDetail />} />
                      <Route path="/control-panel/users/:userId" element={<ClassifiedsUserListings />} />
                      <Route path="/control-panel" element={<ControlPanel />} />
                    </>
                )}
              </Routes>
              <Footer />
              <Notification />
            </AuthHoc>
          )}
        </Provider>
      </CookiesProvider>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
